<div class="game-stat" *ngIf="game && statistic">
  <div class="stats-values">
    <div class="stat-row">
      <div class="value">{{ statistic.team.points || 0}}</div>
      <div class="name">Набрано очков</div>
      <div class="value">{{ statistic.competitorTeam.points || 0 }}</div>
    </div>
    <div class="stat-row">
      <div class="value">{{ statistic.team.serveAces || 0}}</div>
      <div class="name">Эйсов</div>
      <div class="value">{{ statistic.competitorTeam.serveAces || 0 }}</div>
    </div>
    <div class="stat-row">
      <div class="value">{{ statistic.team.servePercent || 0 }}%</div>
      <div class="name">Процент успешных подач</div>
      <div class="value">{{ statistic.competitorTeam.servePercent || 0 }}%</div>
    </div>
    <div class="stat-row">
      <div class="value">{{ statistic.team.attackPercent || 0 }}%</div>
      <div class="name">Процент успешных атак</div>
      <div class="value">{{ statistic.competitorTeam.attackPercent || 0 }}%</div>
    </div>
    <div class="stat-row">
      <div class="value">{{ statistic.team.blockPercent || 0 }}%</div>
      <div class="name">Процент успешных блоков</div>
      <div class="value">{{ statistic.competitorTeam.blockPercent || 0 }}%</div>
    </div>
    <div class="stat-row" *ngIf="!isLight">
      <div class="value">{{ statistic.team.serveReceivePercent || 0 }}%</div>
      <div class="name">Процент успешных приемов подачи</div>
      <div class="value">{{ statistic.competitorTeam.serveReceivePercent || 0 }}%</div>
    </div>
    <div class="stat-row" *ngIf="!isLight">
      <div class="value">{{ statistic.team.receivePercent || 0 }}%</div>
      <div class="name">Процент успешных приемов атак</div>
      <div class="value">{{ statistic.competitorTeam.receivePercent || 0 }}%</div>
    </div>
    <div class="stat-row">
      <div class="value">{{ statistic.team.attackSpikes || 0 }}</div>
      <div class="name">Атака (очки)</div>
      <div class="value">{{ statistic.competitorTeam.attackSpikes || 0 }}</div>
    </div>
    <div class="stat-row">
      <div class="value">{{ statistic.team.stuffBlocks || 0 }}</div>
      <div class="name">Блок (очки)</div>
      <div class="value">{{ statistic.competitorTeam.stuffBlocks || 0 }}</div>
    </div>
  </div>
</div>
